import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { type KeystoneOfferEligibility } from "src/utils/keystone-api-mapping";

import { Heading } from "@icg360/design-system";

import { AvailableOfferCard } from "components/offers/available-offer-card";
import { type Policy } from "gql/types";
import { switchPolicy } from "utils";

import styles from "./offers.module.scss";

type AvailableOffersProps = {
  unenrolledOffers: KeystoneOfferEligibility[];
  heading?: ReactNode;
  policy?: Policy;
  from?: string;
};

export const AvailableOffers = ({
  heading,
  unenrolledOffers,
  policy,
  from,
}: AvailableOffersProps) => {
  const navigate = useNavigate();

  if (!unenrolledOffers.length) {
    return;
  }

  const goToOffer = (path: string) => {
    if (policy) {
      switchPolicy(policy.insightPolicyId, path, from);
    } else {
      navigate(path, { state: { from } });
    }
  };

  return (
    <div>
      {heading}
      <div className={styles.cardsWrapper}>
        {unenrolledOffers.map((offer) => {
          if (offer.offeringInternalName === "ting-offer") {
            return (
              <AvailableOfferCard
                key={offer.offeringInternalName}
                heading="Ting fire prevention"
                subheading="Help prevent electrical fires before they happen"
                imgUrl="/assets/images/offer-card-ting-offer.jpg"
                imgAlt="A person using the Ting mobile app to monitor electrical hazards, with the Ting sensor plugged into a wall in their home."
                buttonText="Learn about Ting"
                buttonAction={() => {
                  goToOffer(`/my/property-services/ting-offer`);
                }}
              />
            );
          } else if (offer.offeringInternalName === "wind-defense") {
            const imgOverlay = (
              <Heading size="xs" className={styles.overlayText}>
                <span className={styles.textDark}>Storm Protection&nbsp;</span>
                |&nbsp;
                <span className={styles.textLight}>Wind Defense</span>
              </Heading>
            );
            return (
              <AvailableOfferCard
                key={offer.offeringInternalName}
                heading="Wind Defense"
                subheading="Sign up for a chance to strengthen your roof before the hurricane season"
                imgUrl="/assets/images/offer-card-wdr.jpg"
                imgAlt="Close-up roof shingles"
                imgOverlay={imgOverlay}
                buttonText="Learn about Wind Defense"
                buttonAction={() => {
                  goToOffer(`/my/property-services/wind-defense`);
                }}
              />
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};
